import React from "react";
import PropTypes from "prop-types";
import styles from "./Modal.module.css";
import classNames from "classnames";
import Portal from "Shared/Portal";

/**
 * Basic layout for modals used in the app
 */

export function Modal({
  isOpen,
  children,
  className,
  onClose,
  centered = true,
}) {
  if (!isOpen) return null;

  return (
    <Portal>
      <div
        className={classNames(styles.overlay, centered && styles.centered)}
        onClick={() => onClose?.()}
        role="presentation"
      >
        <div
          className={classNames(styles.container, className)}
          onClick={(e) => e.stopPropagation()}
        >
          {children}
        </div>
      </div>
    </Portal>
  );
}

Modal.propTypes = {
  /**
   * A string title of the modal
   */
  title: PropTypes.string,
  /**
   * Boolean to determine if modal is open
   */
  isOpen: PropTypes.bool,
  /**
   * Children components to render in the modal
   */
  children: PropTypes.any,
  /**
   * Passed in to make changes to the modal style
   */
  className: PropTypes.string,
  /**
   * Optional callback to close modal when overlay is clicked.
   */
  onClose: PropTypes.func,
  /**
   * Boolean to center the modal vertically. Defaults to true so modals
   * are never cut off at the top of the viewport; pass false to opt into
   * the flush-to-top "dropdown" appearance instead.
   */
  centered: PropTypes.bool,
};
